import { PlatformContext } from '@vivli/core/infrastructure/context';
import { useContextInit, useDomainApiInit, useSearchInit } from '@vivli/core/infrastructure/hook';
import { IPlatformContext } from '@vivli/core/infrastructure/interface';
import { IContextWrapper } from '@vivli/shared/infrastructure/interface';
import { useMemo } from 'react';

export const PlatformContextInitWrapper = ({ children }: IContextWrapper) => {
    const domainApiHooks = useDomainApiInit();
    const contextHooks = useContextInit({ ...domainApiHooks });
    const searchHooks = useSearchInit({
        ...contextHooks
    });

    const provider: IPlatformContext = useMemo(
        () => ({
            ...domainApiHooks,
            ...contextHooks,
            ...searchHooks
        }),
        [domainApiHooks, contextHooks, searchHooks]
    );

    return <PlatformContext.Provider value={provider}>{children}</PlatformContext.Provider>;
};
